import { defer } from 'rxjs';
import http from '../network/http';

export function fetchAllPokemon() {
  // Observable<AxiosResponse<any>>
  return defer(() => http.get(`/pokemon?limit=10&offset=0`));
}
